(function() {
  function initRotatingText() {
    const rotatingElements = document.querySelectorAll('.hero__title-rotating');
    
    rotatingElements.forEach(function(element) {
      const wordsString = element.getAttribute('data-words');

      let phrases = wordsString.split(/\n|,/).map(phrase => phrase.trim()).filter(phrase => phrase);
      
      if (phrases.length === 0) return;
      
      const list = document.createElement('ul');
      list.className = 'hero__title-rotating-list';

      const extendedPhrases = [...phrases, ...phrases, ...phrases];
      
      extendedPhrases.forEach(function(phrase, index) {
        const item = document.createElement('li');
        item.className = 'hero__title-rotating-item';
        item.textContent = phrase;
        list.appendChild(item);
      });
      
      element.innerHTML = '';
      element.appendChild(list);
      
      let currentIndex = phrases.length;
      const items = list.querySelectorAll('.hero__title-rotating-item');
      items[currentIndex].classList.add('active');
      
      list.style.transform = `translateY(-${currentIndex * 1.4}em)`;
      
      if (phrases.length > 1) {
        setInterval(function() {
          if (currentIndex >= phrases.length * 2 - 1) {
            items[currentIndex].classList.remove('active');
            currentIndex++;
            list.style.transform = `translateY(-${currentIndex * 1.4}em)`;
            items[currentIndex].classList.add('active');
            
            setTimeout(function() {
              var oldActiveIndex = currentIndex;
              var newIndex = phrases.length;
              
              items[oldActiveIndex].classList.add('no-transition');
              items[newIndex].classList.add('no-transition');

              items[newIndex].classList.add('active');
              
              list.style.transition = 'none';
              currentIndex = newIndex;
              list.style.transform = `translateY(-${currentIndex * 1.4}em)`;
              
              void list.offsetHeight;
              
              items[oldActiveIndex].classList.remove('active');
              
              setTimeout(function() {
                list.style.transition = 'transform 0.7s cubic-bezier(0.4, 0.0, 0.2, 1)';
                
                items[oldActiveIndex].classList.remove('no-transition');
                items[newIndex].classList.remove('no-transition');
              }, 20);
            }, 700);
          } else {
            items[currentIndex].classList.remove('active');
            currentIndex++;
            list.style.transform = `translateY(-${currentIndex * 1.4}em)`;
            items[currentIndex].classList.add('active');
          }
          
        }, 3500);
      }
    });
  }
  
  // Initialize on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRotatingText);
  } else {
    initRotatingText();
  }
  
  // Re-initialize after Shopify section reload (for theme editor)
  document.addEventListener('shopify:section:load', initRotatingText);
})();
